import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center py-4 mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-4" }
const _hoisted_2 = { class: "rounded-full py-2 px-8 border border-gray-200/50 bg-white/95 shadow-lg backdrop-blur-md" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "flex items-center space-x-6" }
const _hoisted_5 = { class: "flex space-x-6" }
const _hoisted_6 = {
  class: "flex items-center ml-8 relative",
  ref: "dropdownRef"
}
const _hoisted_7 = {
  key: 0,
  class: "absolute right-0 top-full mt-2 w-44 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex items-center gap-2 text-xl font-bold text-brand-600"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: "/logo.webp",
                alt: "Logo",
                class: "h-10 w-8"
              }, null, -1),
              _createTextVNode(" Optyfind ")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "text-gray-500 hover:text-gray-700 text-sm font-medium",
              "active-class": "text-brand-600"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Application tracker ")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/my-skills",
              class: "text-gray-500 hover:text-gray-700 text-sm font-medium",
              "active-class": "text-brand-600"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" My Skills ")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/my-searches",
              class: "text-gray-500 hover:text-gray-700 text-sm font-medium",
              "active-class": "text-brand-600"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Job Searches ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleDropdown && $setup.toggleDropdown(...args))),
            class: "flex items-center gap-1.5 text-gray-700 text-sm font-medium hover:text-gray-900 focus:outline-none"
          }, [
            _createTextVNode(_toDisplayString($setup.userName) + " ", 1),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["h-4 w-4 text-gray-400 transition-transform duration-150", { 'rotate-180': $setup.isOpen }]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]), 2))
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              ($setup.isOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/settings",
                      onClick: $setup.closeDropdown,
                      class: "flex items-center gap-2.5 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 text-gray-400",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          })
                        ], -1),
                        _createTextVNode(" Settings ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      to: "/subscriptions",
                      onClick: $setup.closeDropdown,
                      class: "flex items-center gap-2.5 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 text-gray-400",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                          })
                        ], -1),
                        _createTextVNode(" Subscriptions ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      to: "/billing",
                      onClick: $setup.closeDropdown,
                      class: "flex items-center gap-2.5 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 text-gray-400",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                          })
                        ], -1),
                        _createTextVNode(" Billing ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      to: "/support",
                      onClick: $setup.closeDropdown,
                      class: "flex items-center gap-2.5 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 text-gray-400",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                          })
                        ], -1),
                        _createTextVNode(" Support ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "my-1 border-t border-gray-100" }, null, -1)),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleLogout && $setup.handleLogout(...args))),
                      class: "flex w-full items-center gap-2.5 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("svg", {
                        class: "h-4 w-4 text-gray-400",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        })
                      ], -1),
                      _createTextVNode(" Logout ")
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512)
      ])
    ])
  ]))
}